import React from 'react'
import { Table2 } from 'components'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import placeholderLogo from 'images/icons/labelPlaceholder.png'

const ArtistsTable = ({ items }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const searchBackTo = `${location.pathname}${location.search}${location.hash}`

  const handleClick = (item) => {
    navigate(`/search/releases/artist?q=${encodeURIComponent(item.artist)}`, {
      state: { searchBackTo }
    })
  }

  const columns = [
    {
      image: true,
      src: 'coverart',
      cellStyleName: 'release-coverart',
      fallback: placeholderLogo
    },
    {
      title: t('release-list.artist'),
      field: 'artist',
      cellStyleName: 'release-artist',
      resizable: false,
      cellClassName: 'truncate'
    },
    {
      title: t('release-list.releases'),
      field: 'releases',
      cellStyleName: 'release-releases'
    }
  ]

  return (
    <Table2
      tableId="artists"
      items={items}
      columns={columns}
      onClick={handleClick}
    />
  )
}

ArtistsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object)
}

export default ArtistsTable
